<!-- 只有在組織選擇頁面，才會顯示登入的帳號資訊 -->
@if (!matDialogRef) {
  <div class="user-info" [attr.data-testid]="'user-info-container'">
    <div class="header" [attr.data-testid]="'header-container'">
      <gosu-logo
        theme="yellow"
        [size]="280"
        [attr.data-testid]="'gosu-logo'"
      ></gosu-logo>
      <p class="mat-h2" i18n [attr.data-testid]="'header-description'">
        選擇要登入的組織，或免費建立
      </p>
    </div>
    <div
      class="flex flex-row !align-center !justify-center"
      [attr.data-testid]="'user-account-container'"
    >
      <h1
        class="flex-1"
        *asyncJob="account$; let account"
        [attr.data-testid]="'account-name'"
      >
        {{ account.accountName }}
      </h1>

      <div class="wrap">
        <button
          mat-icon-button
          class="logout"
          (click)="tokenService.logout()"
          [attr.data-testid]="'logout-button'"
        >
          <mat-icon>exit_to_app</mat-icon>
        </button>
      </div>
    </div>
  </div>
}

<div class="title" [attr.data-testid]="'company-selector-title'">
  <mat-label i18n>選擇組織</mat-label>
</div>

<mat-action-list
  class="select-company min-h-[200px]"
  [attr.data-testid]="'companies-list'"
>
  <ng-container *asyncJob="companies$; let companies">
    @for (company of companies; track company.id) {
      <button
        mat-button
        (click)="selectCompany(company)"
        [attr.data-testid]="'company-item-' + company.id"
      >
        <div class="wrap">
          <div class="name" [attr.data-testid]="'company-name-' + company.id">
            {{ company.name }}
          </div>
          <div class="ext">
            <div class="id" [attr.data-testid]="'company-id-' + company.id">
              #{{ company.id }}
            </div>
            <p
              class="created-at"
              i18n
              [attr.data-testid]="'company-created-at-' + company.id"
            >
              {{ company.createdAt | fromNow }}建立
            </p>
          </div>
        </div>
      </button>
    }
  </ng-container>
</mat-action-list>

<button
  mat-button
  color="primary"
  class="create"
  (click)="createCompany()"
  i18n
  [attr.data-testid]="'create-company-button'"
>
  <mat-icon>add</mat-icon>
  建立組織
</button>
